import React from 'react';
import {
  TextField, Button, CardContent, CardHeader,
} from '@material-ui/core';
import GalleryField from 'components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';

import {
  Props,
} from './types';
import { NavigationOptions } from 'screens/addEditCustomScreen/components/navigationOptions';

const GeneralWidgetCard: React.FC<Props> = (props: Props) => (
  (
    <>
      <CardContent>
        <TextField
          value={props.focusedWidgetData.params.title}
          onChange={(event) => props.handleChangeData('title', event.target.value)}
          autoFocus
          margin="dense"
          id="widgetTitle"
          label="Widget Title"
          fullWidth
        />
        <GalleryField
          errors=""
          touched=""
          filedType="GalleryField"
          onAddImage={(name, image) => {
            props.handleChangeData('imageURL', URL.createObjectURL(image));
          }}
          onRemoveImage={() => {
            props.handleChangeData('imageURL', '');
          }}
          name="widgetImage"
          value={props.focusedWidgetData.params.imageURL ? [{
            imageUrl: props.focusedWidgetData.params.imageURL,
          }] : []}
          accept="image/*"
          size={200}
          label="Widget Image"
          isLimitToOneImage
        />
        <NavigationOptions 
          entityId={props.focusedWidgetData.params.entityId}
          redirect= {props.focusedWidgetData.params.redirect}
          handleEntityIdChangeData= {(value: string) => props.handleChangeData('redirect', value) }
          handleRedirectChangeData= {(value: string) => props.handleChangeData('entityId', value) }
        />
        <TextField
          value={props.focusedWidgetData.params.params || ''}
          onChange={(event) => props.handleChangeData('params', event.target.value)}
          autoFocus
          margin="dense"
          id="params"
          label="Widget Params"
          fullWidth
        />
      </CardContent>
    </>
  )
);

export default GeneralWidgetCard;
